<template>
  <div 
    class="memoContainer" 
    v-show="memoObj.viewBln" 
    @click="closeHandler" 
  >
    <div 
      ref="memoWrap" 
      class="memoWrap" 
      :style="posStyles" 
    >
      <p class="placeholder" v-if="memoObj.text == ''">{{ memoObj.placeholder }}</p>
      <p 
        ref="memoWrite" 
        class="memoWrite"
        contenteditable="true" 
        spellcheck="false" 
        @input="inputHandler"
        :value="memoObj.text"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    memoObj : Object , 
  } , 
  data () {
    return {
      pos : {
        gap : 0 , // 실제 갭은 20 이지만 gojs 기본 padding, border의 값을 더해야 한다. 
        left : 0 , 
        top : 0 , 
      } , 
    } 
  } , 
  computed : {
    posStyles () {
      return {
        left : `${ this.pos.left + this.pos.gap }px`, 
        top : `${ this.pos.top }px` , 
      }
    }
  } , 
  watch : {
    memoObj : {
      handler ( info ) {
        const { 
          viewBln , 
          text , 
          obj : {
            docloc : { x : docX , y : docY } , 
            key , 
            location : { x : locX , y : locY } , 
            pos : { left , top } , 
            size : { width , height }
          } , 
        } = info ; 

        this.pos = { ...this.pos , 
          left : docX + left + width , 
          top : docY + top , 
        }
        
        this.openHandler( viewBln , text ) ; 
      } , 
    }
  } , 
  methods : {
    openHandler ( viewBln , text ) {
      if ( !viewBln ) return ; 
      this.$refs.memoWrite.textContent = text ; 
      setTimeout(_=>{
        
        this.$refs.memoWrite.focus() ; 
      } , 100 ) ; 
    } , 
    closeHandler ( e ) {
      e.preventDefault() ; 
      e.stopPropagation() ; 
      if ( !e.target.contains( this.$refs.memoWrap )) {
        this.$refs.memoWrap.focus() ; 
        return ; 
      } 
      
      const { text , obj : { memoBtn }} = this.memoObj ; 
      this.$refs.memoWrite.textContent = '' ; 

      if ( text == '' ) { // 취소 
        memoBtn.visible = false ; 
        this.memoObj.updateHandler({ viewBln : false }) ; 
      } else { // 저장 
        memoBtn.visible = true ; 
        this.memoObj.diagram.selection.each( async ( node )=>{
          node.data.temporaryText = text ; 
          this.memoObj.updateHandler({ viewBln : false , text : '' }) ; 

          console.log({ 
            node , 
            data : node.data , 
          }) ; 

          let {
            data : {
              key , 
              protocolId
            }
          } = node ; 

          console.log({
            node , 
            key , 
            protocolId : Math.abs( protocolId ) , 
            text , 
          }) ; 

          // const parts = this.diagram.findNodeForKey(node.key)
          console.log({
            user : this.user , 
            protocolId , 
            key , 
            text , 
          }) ; 
          const rslt = await this.$wApi.protocol.memo.put({
            protocolId : Math.abs( protocolId ) , 
            tagKey : key , 
            content : text , 
          }) ; 
          // console.log({ rslt }) ; 

					/* let res = await this.$wApi.protocol.protocolContent.get({
						protocolId, 
						tagKey: key
					}) */

          /* 
          "protocolId": 1,
          "tagKey": "d760bb1e-ddaa-45a3-a208-371cbb93c1ff",
          "content": "대상 작업내용" */
          

          /* const body = {
            key,
            parent,
            text,
            tagId: 1,
            json: json ? JSON.parse(json) : defaultJSon,
          };
          try {
            const data = await this.$wApi.protocol.put(body, null, {
            useError: true,
          }); */
          // console.log( this.$wApi ) ; 
          // console.log({
          //   memoObj : this.memoObj , 
          // }) ; 

        }) ; 
      } // end of if else 

    } , 
    inputHandler ( e ) {
      let { $refs : { memoWrite }} = this ; 
      this.memoObj.updateHandler({ 
        text : memoWrite.textContent , 
      }) ; 
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
.memoContainer {
  position: fixed; z-index: 9999; 
  left: 0; top: 0; 
  width: 100%; height: 100%; 
  // background-color: rgba( 0,0,0,0.2 ); 

  .memoWrap {
    position: absolute; 
    border: 1px solid $dark-blue; 
    background: $white;
    min-width: 91px; 
    max-width: 232px; 
    min-height: 33px;
    border-radius: 16.5px;
    display: flex;
    align-items: center;
    padding: calc( var( --default-gap ) / 2 ) var( --default-gap ); 

    .placeholder {
      position: absolute; 
      z-index: 1; 
      color: $gray-9; 
      @include text-prt-m ; 
    }

    .memoWrite {
      position: relative; 
      z-index: 2; 
      font-size: 14px; 
      letter-spacing: -0.2px; 
      color: $dark-blue; 
      word-break: break-all; 
      @include text-prt-m ; 
    }
  }
}
</style>